export default __webpack_public_path__ + "static/media/metalwall1.b2586d1b.png";